import clientPortalClient from './clientPortalClient';

export const loginClient = async (username, password) => {
  const response = await clientPortalClient.post('/api/client-auth/login', { username, password });
  return response.data;
};

export const getClientMe = async () => {
  const response = await clientPortalClient.get('/api/client-auth/me');
  return response.data;
};

export const updateClientAccountSecurity = async (data = {}) => {
  const response = await clientPortalClient.patch('/api/client-auth/account-security', data);
  return response.data;
};

export const getClientDashboard = async () => {
  const response = await clientPortalClient.get('/api/client-portal/dashboard');
  return response.data;
};

export const getClientAiBrief = async (scope = 'overview', data = {}) => {
  const response = await clientPortalClient.post('/api/client-portal/ai/brief', data, {
    params: { scope },
  });
  return response.data;
};

export const chatClientAi = async (data = {}) => {
  const response = await clientPortalClient.post('/api/client-portal/ai/chat', data);
  return response.data;
};

export const speakClientAi = async (text, data = {}) => {
  try {
    const response = await clientPortalClient.post('/api/client-portal/ai/speech', {
      ...data,
      text,
    }, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    const payload = error?.response?.data;
    if (payload instanceof Blob && payload.type?.includes('application/json')) {
      const body = JSON.parse(await payload.text());
      throw new Error(body?.error || body?.message || 'Voice response failed');
    }
    throw error;
  }
};

export const getClientSales = async () => {
  const response = await clientPortalClient.get('/api/client-portal/sales');
  return response.data;
};

export const getClientPerformance = async (params = {}) => {
  const response = await clientPortalClient.get('/api/client-portal/performance', { params });
  return response.data;
};

export const getClientDrops = async () => {
  const response = await clientPortalClient.get('/api/client-portal/drops');
  return response.data;
};

export const getClientCampaigns = async () => {
  const response = await clientPortalClient.get('/api/client-portal/campaigns');
  return response.data;
};

export const getClientCampaign = async (id) => {
  const response = await clientPortalClient.get(`/api/client-portal/campaigns/${id}`);
  return response.data;
};

export const getClientApprovals = async (status = 'all') => {
  const response = await clientPortalClient.get('/api/client-portal/approvals', {
    params: { status },
  });
  return response.data;
};

export const respondToApproval = async (id, data) => {
  const response = await clientPortalClient.post(`/api/client-portal/approvals/${id}/respond`, data);
  return response.data;
};

export const getDirectionNotes = async () => {
  const response = await clientPortalClient.get('/api/client-portal/direction-notes');
  return response.data;
};

export const createDirectionNote = async (data) => {
  const response = await clientPortalClient.post('/api/client-portal/direction-notes', data);
  return response.data;
};

export const getClientTimeline = async () => {
  const response = await clientPortalClient.get('/api/client-portal/timeline');
  return response.data;
};

export const reopenApproval = async (id) => {
  const response = await clientPortalClient.post(`/api/client-portal/approvals/${id}/reopen`);
  return response.data;
};

// Returns { albums: [{ shareGroupId, sessionName, sharedAt, reference, generated[] }] }
export const getClientLooks = async () => {
  const response = await clientPortalClient.get('/api/client-portal/looks');
  return response.data;
};

export const getClientCollection = async () => {
  const response = await clientPortalClient.get('/api/client-portal/collection');
  return response.data;
};

export const requestClientCollectionSample = async (data) => {
  const response = await clientPortalClient.post('/api/client-portal/collection/sample-request', data);
  return response.data;
};

export const getClientAgreement = async () => {
  const response = await clientPortalClient.get('/api/client-portal/agreement');
  return response.data;
};

export const acceptClientAgreement = async (id, data) => {
  const response = await clientPortalClient.post(`/api/client-portal/agreement/${id}/accept`, data);
  return response.data;
};

export const createClientStripeOnboardingLink = async () => {
  const response = await clientPortalClient.post('/api/client-portal/stripe/onboarding-link');
  return response.data;
};

export const getClientStripeStatus = async () => {
  const response = await clientPortalClient.get('/api/client-portal/stripe/status');
  return response.data;
};

export const deleteClientLooks = async (approvalIds) => {
  const response = await clientPortalClient.delete('/api/client-portal/looks', { data: { approvalIds } });
  return response.data;
};
